import { defineStore } from 'pinia';
import { type useTranslation } from '@/composables';

export const useMainStore = defineStore('main', {
	state: () => ({
		translation: {} as ReturnType<typeof useTranslation>,
		hasEliSidebar: false,
	}),
});
